import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconCsReturn: React.FC<IconProps> = ({
  size = 15,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M13.2881 5.17187C13.4862 5.17189 13.6463 5.34599 13.6465 5.56152C13.6465 7.41909 13.4355 9.55171 12.0898 10.957C11.0448 12.048 9.62433 12.6868 8.11328 12.5078L8.85742 13.2637C8.99973 13.4082 9.00426 13.6559 8.86719 13.8164C8.72961 13.9769 8.50185 13.9894 8.35938 13.8447L6.9873 12.4512C6.8118 12.2725 6.80684 11.9665 6.97656 11.7686L8.375 10.1387C8.51249 9.9783 8.73935 9.96498 8.88184 10.1094C9.0243 10.254 9.02818 10.5016 8.89062 10.6621L7.99902 11.7021C9.34441 11.9332 10.6342 11.3951 11.5928 10.3945C12.7039 9.23435 12.9306 7.40955 12.9307 5.56152C12.9309 5.34621 13.0903 5.17216 13.2881 5.17187ZM4.20215 10.1113C4.58012 10.15 4.875 10.4693 4.875 10.8574V12.3574C4.875 12.7456 4.58012 13.0649 4.20215 13.1035L4.125 13.1074H1.125C0.710786 13.1074 0.375 12.7716 0.375 12.3574L0.375 10.8574C0.375 10.4432 0.710786 10.1074 1.125 10.1074H4.125L4.20215 10.1113ZM1.125 12.3574H4.125V10.8574H1.125L1.125 12.3574ZM7.875 5.60742C8.28921 5.60742 8.625 5.94321 8.625 6.35742V7.85742C8.625 8.24559 8.33012 8.56489 7.95215 8.60352L7.875 8.60742H1.125L1.04785 8.60352C0.669882 8.56489 0.375 8.24559 0.375 7.85742L0.375 6.35742C0.375 5.94321 0.710786 5.60742 1.125 5.60742H7.875ZM1.125 7.85742H7.875V6.35742H1.125V7.85742ZM10.3896 1.2041C10.7676 1.24275 11.0625 1.56205 11.0625 1.9502V3.3584L11.0586 3.43457C11.0226 3.78727 10.7423 4.06847 10.3896 4.10449L10.3125 4.1084H1.125L1.04785 4.10449C0.695165 4.06847 0.414861 3.78728 0.378906 3.43457L0.375 3.3584L0.375 1.9502C0.375 1.53598 0.710786 1.2002 1.125 1.2002L10.3125 1.2002L10.3896 1.2041ZM13.9521 1.2041C14.3301 1.24274 14.625 1.56204 14.625 1.9502V3.3584L14.6211 3.43457C14.5851 3.78728 14.3048 4.06847 13.9521 4.10449L13.875 4.1084H12.7031L12.626 4.10449C12.2733 4.06847 11.993 3.78728 11.957 3.43457L11.9531 3.3584V1.9502C11.9531 1.56204 12.248 1.24274 12.626 1.2041L12.7031 1.2002H13.875L13.9521 1.2041ZM12.7031 3.3584H13.875V1.9502L12.7031 1.9502V3.3584ZM1.125 3.3584L10.3125 3.3584V1.9502L1.125 1.9502V3.3584Z"
      fill="currentColor"
    />
  </svg>
);

export default IconCsReturn;
